module.exports = "/_next/static/chunks/images/homepage-desktop-side-a25d9bfe04be504474e879e7b05172f9.svg";